import React from 'react';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import { SEO } from '../../components/SEO/SEO';

export const Blogs = () => {
  const blogPosts = [
    {
      title: "How to Find Your Flow in 2026",
      category: "Lifestyle",
      date: "Jan 7, 2026",
      image: "https://images.unsplash.com/photo-1549443545-ade29e416a05?auto=format&fit=crop&q=80&w=800",
      excerpt: "Routine can be suffocating. Here's a guide to discovering activities that actually energize you."
    },
    {
      title: "Top 5 Creative Workshops in Mumbai",
      category: "Workshops",
      date: "Jan 5, 2026",
      image: "https://images.unsplash.com/photo-1513364776144-60967b0f800f?auto=format&fit=crop&q=80&w=800",
      excerpt: "From pottery to charcoal painting, these workshops are perfect for a weekend recharge."
    },
    {
      title: "Building Connections Through Hobbies",
      category: "Community",
      date: "Jan 2, 2026",
      image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&q=80&w=800",
      excerpt: "Why group activities are more than just fun—they are the foundation of modern communities."
    }
  ];

  return (
    <>
      <SEO 
        title="Hobi Hub Blogs | Stories, Tips & Community"
        description="Explore the Hobi Hub blog for insights on discovering hobbies, workshop recommendations, and stories from our community."
        keywords="Hobi blog, hobby tips, lifestyle blog, Mumbai workshops, community stories"
        canonicalUrl="https://hobi.co.in/blogs"
      />
      <section className='hero-bg'>
        <Navbar dark={false} />
        
        <div className="hero">
          <div className="hero-container">
            <div className="hero-box">
              <div className="hero-center">
                <h3 className="heading-italic" style={{ opacity: 1 }}>The Hobi Blog</h3>
                <h1 className="hero-h1" style={{ opacity: 1 }}>Insights, Stories & Your Next Inspiration.</h1>
                <div className="home-desc" style={{ opacity: 1 }}>
                  <p className="hero-p">
                    Stay updated with the latest trends in the world of hobbies and experiences.
                  </p>
                </div>
              </div>
              <div className="hero-bottom" style={{ opacity: 1 }}>
                <img
                  src="/images/bg-edited.svg"
                  loading="lazy"
                  alt="Hobi Hub Blogs"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <main style={{ padding: '80px 0', background: '#f9f9f9' }}>
        <div className="container-medium">
          <div className="blogs-grid" style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
            gap: '40px' 
          }}>
            {blogPosts.map((post, index) => (
              <div key={index} className="blog-card" style={{ 
                borderRadius: '32px', 
                overflow: 'hidden', 
                background: '#ffffff',
                border: '1px solid rgba(0,0,0,0.05)',
                transition: 'all 0.4s ease',
                boxShadow: '0 10px 30px rgba(0,0,0,0.03)'
              }}>
                <img 
                  src={post.image} 
                  alt={post.title} 
                  style={{ width: '100%', height: '260px', objectFit: 'cover' }} 
                />
                <div style={{ padding: '35px' }}>
                  <div style={{ display: 'flex', gap: '15px', marginBottom: '15px', color: '#ff7e5f', fontSize: '14px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>
                    <span>{post.category}</span>
                    <span style={{ opacity: 0.2, color: '#000' }}>|</span>
                    <span style={{ color: '#888' }}>{post.date}</span>
                  </div>
                  <h2 style={{ fontSize: '26px', marginBottom: '18px', color: '#1a1a1a', fontFamily: 'Inter, sans-serif', fontWeight: '700', lineHeight: '1.3' }}>{post.title}</h2>
                  <p style={{ color: '#555', opacity: 0.9, marginBottom: '25px', lineHeight: '1.7', fontSize: '16px' }}>{post.excerpt}</p>
                  <a href="/#" style={{ color: '#ff7e5f', textDecoration: 'none', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '15px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Read Full Story 
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main> */}

      <Footer />
    </>
  );
};
